module.exports = __webpack_public_path__ + "img/clock.1ecde75f.png";